"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var PersonaCheckBoxContainer = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaCheckBoxContainer, _super);
    function PersonaCheckBoxContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PersonaCheckBoxContainer.prototype.render = function () {
        var personaCheckboxClasses = classNames(styles.personaCheckboxContainer, !this.props.isReadingPanePositionOff && 'personaMarginThreeColumn');
        var checkboxClasses = classNames(styles.checkbox, this.props.isSelected && styles.checkboxChecked, 'fbAdLink');
        return (React.createElement("div", { className: personaCheckboxClasses },
            React.createElement("div", { className: styles.persona }),
            React.createElement("div", { className: checkboxClasses })));
    };
    PersonaCheckBoxContainer = tslib_1.__decorate([
        mobx_react_1.observer
    ], PersonaCheckBoxContainer);
    return PersonaCheckBoxContainer;
}(React.Component));
exports.default = PersonaCheckBoxContainer;
//# sourceMappingURL=PersonaCheckboxContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/PersonaCheckboxContainer.js
// module id = 3912
// module chunks = 67